// eslint-disable-next-line import/no-webpack-loader-syntax
import NetworkTesterWorker from "worker-loader!./networkTester";

export default NetworkTesterWorker;
